import React, { PureComponent } from 'react'
import { Button, Popconfirm, Tooltip, Icon, Collapse, Pagination } from 'antd'
import CreateAddressForm from '../../components/CreateAddressForm'
import { get, drop } from 'lodash'

const { Panel } = Collapse

class AddressesTable extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      page: 1
    }
  }
  setPage = page => {
    this.setState({
      page
    })
  }
  getData = () => {
    const { addressActions } = this.props
    return get(addressActions, 'payload.data', [])
  }
  getPagedData = () => {
    const { page } = this.state
    const data = this.getData()
    const offset = (page - 1) * 5
    return drop(data, offset).slice(0, 5)
  }
  renderElement = data => {
    const {
      handleMakePrimaryAddress,
      handleEditAddress,
      handleDeleteAddress,
      cancelDelete
    } = this.props
    const { id, address1, address2, city, state, zip, is_primary_address } = data
    const addressText = `${address1 !== null && address1}${
      address2 !== null ? ' ' + address2 : ''
    }${city !== null ? ', ' + city : ''}${state !== null ? ' - ' + state : ''}${
      zip !== null ? ' - ' + zip : ''
    }`
    return (
      <Panel header={addressText} key={id}>
        <div className="row">
          <div className="col-md-10">
            <div className="jobDetailsHeader">Address:</div>
            <Tooltip title={addressText}>{addressText}</Tooltip>
          </div>
          <div className="col-md-2">
            <div className="jobDetailsHeader">Actions:</div>
            <Popconfirm
              title="Are you sure you want to make this the primary address for this company?"
              onConfirm={() => handleMakePrimaryAddress(id)}
              onCancel={cancelDelete}
              okText="Yes"
              cancelText="No"
            >
              <Button size="small" type="link" style={{ color: '#1F45B4' }}>
                <Icon type="star" theme={is_primary_address ? 'filled' : 'outlined'} />
              </Button>
            </Popconfirm>
            <Button
              size="small"
              className="marginLeft5"
              icon="edit"
              onClick={() => handleEditAddress(data)}
            />
            <Popconfirm
              title="Are you sure you want to delete this line?"
              onConfirm={() => handleDeleteAddress(id)}
              onCancel={cancelDelete}
              okText="Yes"
              cancelText="No"
            >
              <Button size="small" className="marginLeft5" type="danger" icon="delete" />
            </Popconfirm>
          </div>
        </div>
      </Panel>
    )
  }
  render() {
    const {
      addressFormShowing,
      handleAddAddressButton,
      handleCancelAddressButton,
      handleCreateAddressButton,
      handleSaveAddressButton,
      addressData
    } = this.props
    return (
      <div className="row">
        <div className="col-md-12">
          <div className="">
            <div className="jobsBar">
              Addresses
              {!addressFormShowing && (
                <div className="jobsBarAdd" onClick={handleAddAddressButton}>
                  <i className="fa fa-pencil-square" aria-hidden="true" />
                  &nbsp;<div className="addJobLabel">ADD ADDRESS</div>
                </div>
              )}
              {addressFormShowing && (
                <div className="displayFlex">
                  <div className="jobsBarAdd" onClick={handleCancelAddressButton}>
                    <i className="fa fa-ban" aria-hidden="true" />
                    &nbsp;<div className="addJobLabel">CANCEL</div>
                  </div>
                </div>
              )}
            </div>
            {addressFormShowing && (
              <CreateAddressForm
                addAddress={handleCreateAddressButton}
                saveAddress={handleSaveAddressButton}
                contentData={addressData}
              />
            )}
            <Collapse accordion>{this.getPagedData().map(this.renderElement)}</Collapse>
            <Pagination
              total={this.getData().length}
              pageSize={5}
              defaultCurrent={1}
              onChange={this.setPage}
              current={this.state.page}
            />
          </div>
        </div>
      </div>
    )
  }
}

export default AddressesTable



// WEBPACK FOOTER //
// ./src/containers/companies/AddressesTable.js